export default "__VITE_ASSET__1b08ce39__"